<div
     [class.active]="shoppingcartHasItems()"
     [bas-tooltip]="shoppingcartTooltip() | msgKey">
	<a routerLink="/workflow.do?from=menu&to=shoppingcart">
		<mat-icon svgIcon="shopping_cart"></mat-icon>
	</a>
</div>